import styles from './styles';

import * as React from 'react';

import { computed } from 'mobx';
import { observer } from 'mobx-react';

import { bind } from 'bind-decorator';

import type { WithStyles } from '@material-ui/core';
import Drawing from './drawing';

import { Button } from '@material-ui/core';

import { withStyles } from '@material-ui/core';

interface IProps extends WithStyles<typeof styles> {
  value?: null | string;
  readOnly: boolean;
  errored?: boolean;
  warning: boolean;
  strokeColor: string;
  strokeWidth: number;

  onChange: (value: string | null) => void;
}

@observer
class SignatureControl extends React.Component<IProps> {
  @bind
  onClear(): void {
    this.props.onChange(null);
  }

  @computed
  get className() {
    const { classes, errored, warning, value } = this.props;
    let border = '';
    if (!!errored) {
      border = classes.error;
    } else if (!!warning && value == null) {
      border = classes.warning;
    }

    return `${classes.container} ${border}`;
  }

  render() {
    const { onClear, className } = this;
    const { strokeColor, strokeWidth, readOnly, classes, value, onChange } = this.props;

    const clearBtn = !readOnly ? (
      <Button variant="outlined" size="medium" onClick={onClear}>
        Clear
      </Button>
    ) : null;

    return (
      <span className={className}>
        <h4 className={classes.header}>Signature:</h4>
        <div className={classes.clear}>{clearBtn}</div>
        <Drawing
          value={value}
          strokeColor={strokeColor}
          strokeWidth={strokeWidth}
          readOnly={readOnly}
          onChange={onChange}
        />
      </span>
    );
  }
}

export default withStyles(styles, { name: 'Signature-Control' })(SignatureControl);
